import { option } from 'fp-ts';

export type NoOp = () => void;
export type NoOpOption<T> = (value: option.Option<T>) => void;
/**
 * **noop**_()_<br>
 * Helper function to use as placeholder non-operating functions. (Mainly as defaultProp functions).
 * @returns { void }
 */
export const noop: NoOp = () => undefined;

export function noopOption<T>(_value: option.Option<T> = option.none): void {
  // do nothing
}

export default noop;
